import React, { useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import uploading from '../Photoset/uploading.png';
import './UpdateActivity.css';

function CreateUserActivity() {
    const [image, setImage] = useState(null);
    const [name, setName] = useState('');
    const [date, setDate] = useState('');
    const [link, setLink] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('image', image);
        formData.append('name', name);
        formData.append('date', date);
        formData.append('link', link);

        try {
            const response = await axios.post('https://school-web-server-eight.vercel.app/createactivity', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            console.log('Activity created:', response.data);
            navigate('/login/updateactivity');
        } catch (error) {
            console.error('Error creating activity:', error);
        }
    };

    const inputRef = useRef(null);

    const handleImageClick = () => {
        inputRef.current.click();
    }

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (!file || file.length === 0) {
            console.error("No file selected.");
            return;
        }
        const imgname = event.target.files[0].name;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            const img = new Image();
            img.src = reader.result;
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.toBlob(
                    (blob) => {
                        const file = new File([blob], imgname, {
                            type: "image/png",
                            lastModified: Date.now(),
                        });

                        console.log(file);
                        setImage(event.target.files[0]);
                    },
                    "image/jpeg",
                    0.8
                );
            };
        };
    };


    return (
        <div className='activity-create'>
                    <h2>เพิ่มกิจกรรม</h2>
                    <form onSubmit={handleSubmit}>
                        <div className='activity-create-info'>
                            <div className='ac-2'>
                                <div className='ac-2-text-1'><label htmlFor="">รูปภาพ</label></div>
                                <div className="image" onClick={handleImageClick} style={{ cursor: "pointer" }}>
                                    <div className="imgupload">{image ? (<img src={URL.createObjectURL(image)} alt="" />) : (<img src={uploading} alt="" />)}</div>
                                    <input
                                        type="file"
                                        ref={inputRef}
                                        onChange={handleImageChange}
                                        style={{ display: "none" }} />
                                </div>
                            </div>
                            <div className='ac-2'>
                                <div className='ac-2-text'><label htmlFor="">เรื่อง</label></div>
                                <div className='text-input'><input
                                    type="text"
                                    placeholder='เพิ่มชื่อเรื่อง'
                                    className='form-control-1'
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                /></div>
                                
                            </div>
                            <div className='ac-2'>
                                <div className='ac-2-text'><label htmlFor="">วันที่อัปโหลด</label></div>
                                <div className='text-input'> <input
                                    type="date"
                                    className='form-control-1'
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    required
                                /></div>
                               
                            </div>
                            <div className='ac-2'>
                                <div className='ac-2-text'><label htmlFor="">เพิ่มลิงค์</label></div>
                                <div className='text-input'><input
                                    type="url"
                                    placeholder='เพิ่มลิงค์'
                                    className='form-control-1'
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                    required
                                /></div>
                                
                            </div>
                            <button className='btn-success' type='submit'>เพิ่มข้อมูล</button>
                        </div>
                    </form>
        </div>
    );
}

export default CreateUserActivity;
